import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function About() {
  return (
    <div className="page">

    	<div className="app-body-wrapper">
		    <div className="app-body animate__animated animate__fadeInUpBig">

		    <br />
		    <br />
		    <br />
		      &nbsp;

		      <div className="app-center">
		      Mallbrawlreds does not endorse, encourage, or condone the use, consumption, or promotion of cigarettes, cigars, vaping products, or any other form of tobacco or nicotine-containing substances.
< br />
< br />
Mallbrawlreds is wholly independent from, has no affiliation, association, sponsorship, or endorsement relationship with, and is not in any way connected to any tobacco manufacturer, distributor, brand, or related commercial entity. 
< br />
		      <br /> <br />
		    		Questions, Compliments, Complaints? <a href="mailto:mallbrawlreds@gmail.com">mallbrawlreds@gmail.com</a>
		      <br /> <br /> <br />
		      <a href="/privacy">Privacy Policy</a>
		    	</div>

		    </div>
	    </div>

	    <br /> <br />&nbsp;

    </div>
  )
}

export default About
